const puzzle = {
  id: "MlFtYajockviA0qijsh0",
  name: "The Icons of Strategy",
  rebuses: [
    {
      style: {},
      id: "555bc3de-e243-48a5-879b-ac8eff4c1702",
      solutionInfo: {
        solvedText: "Bishop",
        type: "text",
        possibleSolutions: [
          {
            id: "242abe7a-d743-46c9-9a8d-1b10d4377952",
            value: "Bishop",
          },
          {
            id: "242555be7a-d743-46c9-9a8d-1b10d4377952",
            value: "Bishops",
          },
        ],
      },
      clues: [
        {
          clueGroup: 0,
          clueValues: [
            {
              id: "7071d4fb-4e6c-4de0-888c-756a2746e2d8",
              subtext: "",
              value: "G5FBSTi4.png",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          id: "609f07e2-7e55-473e-b70a-38dc2c1a0f13",
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            "See what you can find about the hierarchy of the Catholic Church",
          dependsOn: [],
        },
      ],
    },
    {
      clues: [
        {
          dependsOn: [],
          clueGroup: 0,
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              value: "PawnWordSearch",
              type: "customComponent",
              id: "a0e9cd99-771a-44e5-aca7-42ee9cb16cf8",
            },
          ],
          helperText: "Find all the words and type in what's left.",
          style: {
            width: "calc(40% - 10px)",
          },
          subtext: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          id: "af3fd753-6949-4be2-b56c-d0124a3e3809",
        },
      ],
      id: "447d7cf6-2af6-44f6-8178-491efffd5f43",
      style: {},
      solutionInfo: {
        solvedText: "Pawn",
        possibleSolutions: [
          {
            id: "53c61f30-f079-4821-9b92-97f57a530a0e",
            value: "Pawn",
          },
        ],
        type: "text",
      },
    },
    {
      id: "669721c3-4148-4b12-9d5c-cf4fac2a113b",
      solutionInfo: {
        possibleSolutions: [
          {
            id: "2ddb1532-1092-44af-ad9e-babe0e3234bc",
            value: "Knight",
          },
        ],
        solvedText: "Knight",
        type: "text",
      },
      style: {},
      clues: [
        {
          id: "8662ba0b-6e3a-4037-9b73-256dcd067035",
          helperText:
            "What word (opposite of white) do these three terms have in common?",
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          dependsOn: [],
          clueValues: [
            {
              subtext: "Belt, Hole, Widow",
              id: "7838309e-b361-45ad-aa88-a1b97fea40a7",
              type: "image",
              value: "NnVsm5rs.png",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          clueGroup: 0,
          solutionInfo: {
            type: "text",
            solvedText: "Black",
            possibleSolutions: [
              {
                id: "f8468bcd-3b58-46fe-9218-d0e46bc6e3da",
                value: "Black",
              },
            ],
          },
        },
        {
          dependsOn: [],
          clueValues: [
            {
              value: "CXuQHghH.png",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Valentine's, Independence, Judgement",
              id: "18e86937-b0d7-4bab-a492-768cb114e4df",
            },
          ],
          clueGroup: 0,
          subtext: "",
          helperText:
            "What word (opposite of night) do these three terms have in common?",
          id: "26223201-ba08-4780-a6b4-accfacf8eabc",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "61bc1f2b-05e7-443c-bdf1-46c047616398",
                value: "Day",
              },
            ],
            solvedText: "Day",
          },
        },
        {
          dependsOn: [],
          clueGroup: 0,
          clueValues: [
            {
              value: "NnVsm5rs.png",
              type: "image",
              id: "9e1bfc87-3255-4aa3-9e7b-a21b6b0d0b41",
              subtext: "Web, Matter, Chocolate",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            "What word (opposite of light) do these three terms have in common?",
          subtext: "",
          id: "243a230e-2d9f-445e-92ae-8041681ffb10",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "c1a36c2c-1d96-4e4f-88e2-e252f452e555",
                value: "Dark",
              },
            ],
            type: "text",
            solvedText: "Dark",
          },
        },
        {
          clueGroup: 1,
          dependsOn: [
            {
              id: "8996d5db-43a6-4f6d-a58f-c3aa580e2e50",
              value: "8662ba0b-6e3a-4037-9b73-256dcd067035",
            },
            {
              id: "303afc22-cf38-4bc6-ad71-4386f9a46865",
              value: "26223201-ba08-4780-a6b4-accfacf8eabc",
            },
            {
              id: "68f7eb1e-4a21-417c-b43f-e59783f789e9",
              value: "243a230e-2d9f-445e-92ae-8041681ffb10",
            },
          ],
          id: "e63916d7-29b9-43be-b441-cfcc2e32955d",
          clueValues: [
            {
              type: "text",
              subtext: "2001.",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Black",
              id: "bcf8547d-7f76-4928-9910-b92600e3e91a",
            },
          ],
          helperText: "",
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
        },
        {
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "e4ba9069-9b60-484d-9662-2c907fdca2fc",
          clueGroup: 2,
          dependsOn: [
            {
              id: "08defa0a-06da-4654-aeae-876197665e7e",
              value: "243a230e-2d9f-445e-92ae-8041681ffb10",
            },
            {
              value: "26223201-ba08-4780-a6b4-accfacf8eabc",
              id: "ffa5a9cf-ebae-4e27-a0de-09d773fea966",
            },
            {
              id: "fee8c5c9-6f25-4c0b-9b01-f67f4f213c14",
              value: "8662ba0b-6e3a-4037-9b73-256dcd067035",
            },
          ],
          helperText: "",
          clueValues: [
            {
              type: "text",
              value: "And Day",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "66e0809a-4c45-4b86-b233-630908c76f31",
              subtext: "2010.",
            },
          ],
        },
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "Dark",
              id: "e4226f18-f572-46bd-8b6f-fa02c3a7a0e4",
              subtext: "2008.",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [
            {
              value: "243a230e-2d9f-445e-92ae-8041681ffb10",
              id: "d46956e0-2a34-45b2-a874-2c52cded004a",
            },
            {
              id: "cdd3d307-aa87-4399-a16f-b6e1e5ffd34d",
              value: "26223201-ba08-4780-a6b4-accfacf8eabc",
            },
            {
              value: "8662ba0b-6e3a-4037-9b73-256dcd067035",
              id: "01f84728-33cf-4b68-9591-7eb6c30e244c",
            },
          ],
          helperText: "",
          id: "872b2aad-9f5c-4504-af30-ccfc72fc33c1",
          clueGroup: 3,
          subtext: "",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
        },
      ],
    },
    {
      style: {},
      solutionInfo: {
        solvedText: "Chess",
        type: "text",
        possibleSolutions: [
          {
            value: "Chess",
            id: "03cffaaf-e977-4913-b130-3669749cdb0e",
          },
        ],
      },
      id: "6cd4c47d-79f2-4513-a04b-2ae324e371ac",
      clues: [
        {
          subtext: "",
          clueGroup: 1,
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          dependsOn: [],
          helperText: "A piece used in a board game we're looking for.",
          id: "21d60427-918f-464e-8878-ef8ce15f7bfa",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Bishop",
              id: "f7e9c7d3-f416-4ade-8d66-53e6c92d32fe",
              type: "text",
            },
          ],
        },
        {
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          helperText: "A piece used in a board game we're looking for.",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "147bb811-b5c7-49f8-94da-89d420f94d2b",
          clueGroup: 1,
          dependsOn: [],
          clueValues: [
            {
              id: "2d7c3151-bfeb-4b41-899e-3756d2d919b0",
              value: "Pawn",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              type: "text",
            },
          ],
          subtext: "",
        },
        {
          dependsOn: [],
          clueGroup: 1,
          subtext: "",
          clueValues: [
            {
              value: "Knight",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "72edb525-3f6d-4059-ac60-dff69e25cd78",
              type: "text",
            },
          ],
          id: "56bd1d8b-3a9f-4bc0-95f3-074b59e35807",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          helperText: "A piece used in a board game we're looking for.",
        },
      ],
    },
  ],
};

export default puzzle;
